/* eslint-disable import/no-anonymous-default-export */

export default [
  { name: "خانه", link: "/" },
  {
    name: "راهنما",
    link: "/howitworks",
    websiteAddress: true,
  },
  { name: "تقاضای مسیر", link: "/survey" },
  {
    name: "سوالات متداول",
    link: "/faq",
    websiteAddress: true,
  },
  {
    name: "پشتیبانی",
    link: "/support",
    websiteAddress: true,
  },
];
